namespace Matrix.Data {
    export interface MarketExchangeForm {
        Mic: Serenity.StringEditor;
        CountryName: Serenity.StringEditor;
        CountryCode: Serenity.StringEditor;
        OperatingMic: Serenity.StringEditor;
        OS: Serenity.StringEditor;
        Name: Serenity.StringEditor;
        Acronym: Serenity.StringEditor;
        City: Serenity.StringEditor;
        Website: Serenity.StringEditor;
        StatusDate: Serenity.DateEditor;
        Status: Serenity.StringEditor;
        CreationDate: Serenity.DateEditor;
        Comments: Serenity.StringEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class MarketExchangeForm extends Serenity.PrefixedContext {
        static formKey = 'Data.MarketExchange';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!MarketExchangeForm.init)  {
                MarketExchangeForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = StaticTextBlock;
                var w3 = ReadOnlyDateTime;

                Q.initFormType(MarketExchangeForm, [
                    'Mic', w0,
                    'CountryName', w0,
                    'CountryCode', w0,
                    'OperatingMic', w0,
                    'OS', w0,
                    'Name', w0,
                    'Acronym', w0,
                    'City', w0,
                    'Website', w0,
                    'StatusDate', w1,
                    'Status', w0,
                    'CreationDate', w1,
                    'Comments', w0,
                    'CreatedBy', w2,
                    'CreatedWhen', w3,
                    'UpdatedBy', w2,
                    'UpdatedWhen', w3,
                    'Version', w2
                ]);
            }
        }
    }
}
